import React from 'react';
import { CalendarDays, ArrowRight } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';
import AvailabilityCalendar from './AvailabilityCalendar';

const FreeConsultation = () => {
  const { t } = useLang();

  // Pre-fill the contact form's message with the chosen date.
  const handleSelect = (iso, status) => {
    const target = document.getElementById('contact-form');
    const msg = document.querySelector('[data-testid="contact-input-message"]');
    if (msg) {
      const prefix = status === 'limited'
        ? `Preferred date (limited slots): ${iso}\n\n`
        : `Preferred date: ${iso}\n\n`;
      msg.value = prefix + (msg.value || '');
      msg.dispatchEvent(new Event('input', { bubbles: true }));
    }
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="consultation" className="py-24 md:py-32 bg-[#0B3D2E] relative overflow-hidden">
      <div className="absolute top-10 left-1/4 w-96 h-96 rounded-full bg-[#D4AF37]/8 blur-3xl pointer-events-none" />

      <div className="max-w-[1280px] mx-auto px-6 grid md:grid-cols-2 gap-12 lg:gap-14 items-center">
        <div>
          <h2 className="font-serif-display text-4xl md:text-6xl leading-tight mb-6">
            <span className="peach-text italic">{t('fc.kicker')}</span>
          </h2>
          <p className="text-[#ffffff]/80 text-xl leading-relaxed mb-8 max-w-md">
            {t('fc.title')}
          </p>
          <p className="text-[#ffffff]/65 text-base leading-relaxed mb-10 max-w-md">
            {t('fc.sub')}
          </p>
          <a
            href="#contact-form"
            data-testid="fc-cta"
            className="btn-gold inline-flex items-center gap-3 px-10 py-4 rounded-full text-base group"
          >
            {t('cta.bookFreeConsultation')}
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </a>

          <div className="mt-10 flex items-center gap-2 text-[#D4AF37]/85 text-xs tracking-[0.22em] uppercase">
            <CalendarDays className="w-4 h-4" />
            <span>{t('avail.helper', 'Tap an available date — we\u2019ll prefill the form for you.')}</span>
          </div>
        </div>

        {/* Right column: live availability calendar replacing the clock */}
        <div className="relative">
          <div className="rounded-3xl bg-[#072A1F]/70 backdrop-blur-sm border border-[#D4AF37]/15 p-5 sm:p-7 shadow-[0_30px_70px_-20px_rgba(0,0,0,0.55)]">
            <AvailabilityCalendar onSelectDate={handleSelect} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FreeConsultation;
